export default "/static/9009a4c564ff94cf.svg"